    // utils
const withAlpha = (hex: string, a = 0.12) => {
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map(c => c + c).join("") : h;
  const n = parseInt(full, 16);
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

type IconHeadingProps = {
  label: string;
  iconUrl: string;     // your SVG/PNG mask
  color: string;       // e.g. "#f54a00"
};

export const IconHeading: React.FC<IconHeadingProps> = ({ label, iconUrl, color }) => (
  <h6 className="mb-0 d-flex align-items-center mt-2" style={{ gap: 10 }}>
    <span
      className="pi-badge"
      style={{
        background: withAlpha(color, 0.19),              // soft fill derived from icon color
        border: `1px solid ${withAlpha(color, 0.28)}`,   // subtle ring
      }}
    >
      <span
        className="pi-icon"
        aria-hidden="true"
        style={{
          WebkitMaskImage: `url(${iconUrl})`,
          maskImage: `url(${iconUrl})`,
          backgroundColor: color,                        // the icon itself
        }}
      />
    </span>
    <span>{label}</span>
  </h6>
);
